import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import SiteService from "../../../service/SiteService";
import CodeBlock from "../../../common/CodeBlock";

class Samples extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Samples</h1>
                                <p>Welcome to the {SiteService.getSiteName()} samples cookbook.</p>
                                <p>Here you'll find recipes to accomplish particular tasks. Feel free to combine and adapt these to your needs.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h3>Simple HTTP GET endpoint</h3>
                                <ul>
                                    <li>This example defines the endpoint <code>/pets</code> as expecting an HTTP <code>GET</code> request</li>
                                    <li>This example will produce a JSON response</li>
                                    <li>One response is defined for the HTTP 200 case</li>
                                    <li>This example defines a basic data model in the <code>definitions</code> section — this is standard <a
                                        href="https://json-schema.org/">JSON Schema</a></li>
                                    <li>This provides an example response payload — in the form of a JSON array</li>
                                </ul>
                                <CodeBlock code={`---
swagger: "2.0"
info:
  version: "1.0.0"
  title: "Petstore"
consumes:
- "application/json"
produces:
- "application/json"
paths:
  /pets:
    get:
      description: "Returns all pets from the system"
      produces:
        - "application/json"
      responses:
        "200":
          description: "A list of pets."
          schema:
            type: "array"
            items:
              $ref: "#/definitions/Pet"
          examples:
            application/json: |-
              [
                {
                  "id": 101,
                  "name": "Cat"
                },
                {
                  "id": 102,
                  "name": "Dog"
                }
              ]
definitions:
  Pet:
    type: "object"
    required:
      - "id"
      - "name"
    properties:
      id:
        type: "integer"
        format: "int64"
      name:
        type: "string"
`}/>
                                <blockquote>
                                    <i>Note</i>: There is much more to OpenAPI than this. Check out <a
                                    href="https://github.com/OAI/OpenAPI-Specification/blob/master/versions/2.0.md">the specification</a> for more info.
                                </blockquote>

                                <hr/>
                                <h3>Multiple CRUD endpoints</h3>
                                <p>This example provides an endpoint that accepts common CRUD verbs -
                                    HTTP <code>GET</code>, <code>POST</code>, <code>PUT</code> and <code>DELETE</code>.</p>
                                <p>Here you can:</p>
                                <ul>
                                    <li>add a new pet</li>
                                    <li>list all pets</li>
                                    <li>fetch a single pet</li>
                                    <li>update an existing pet</li>
                                    <li>delete a pet</li>
                                </ul>
                                <CodeBlock code={`---
swagger: "2.0"
info:
  version: "1.0.0"
  title: "Petstore"
consumes:
- "application/json"
produces:
- "application/json"
paths:
  /pets:
    post:
      description: "Add a pet to the system."
      parameters:
      - name: pet
        in: body
        description: the pet to be created
        required: true
        schema:
          $ref: "#/definitions/NewPet"
      responses:
        "201":
          description: "Pet creation confirmation."
    get:
      description: "Returns all pets from the system."
      produces:
        - "application/json"
      responses:
        "200":
          description: "A list of pets."
          schema:
            type: "array"
            items:
              $ref: "#/definitions/Pet"
          examples:
            application/json: |-
              [
                {
                  "id": 101,
                  "name": "Cat"
                },
                {
                  "id": 102,
                  "name": "Dog"
                }
              ]
  /pets/{petId}:
    get:
      description: "Fetch a pet from the system."
      parameters:
      - name: petId
        in: path
        description: the pet to be fetched
        required: true
        type: integer
      responses:
        "200":
          description: "Pet."
          schema:
            $ref: '#/definitions/Pet'
    put:
      description: "Update a pet in the system."
      parameters:
      - name: petId
        in: path
        description: the pet to be updated
        required: true
        type: integer
      - name: pet
        in: body
        description: the pet to be updated
        required: true
        schema:
          $ref: "#/definitions/NewPet"
      responses:
        "201":
          description: "Pet creation confirmation."
    delete:
      description: "Delete a pet from the system."
      parameters:
      - name: petId
        in: path
        description: the pet to be deleted
        required: true
        type: integer
      responses:
        "200":
          description: "Pet deletion confirmation."
definitions:
  Pet:
    type: "object"
    allOf:
      - $ref: "#/definitions/NewPet"
      - required:
          - "id"
        properties:
          id:
            type: "integer"
            format: "int64"
  NewPet:
    type: "object"
    required:
      - "name"
    properties:
      name:
        type: "string"
`}/>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Samples;



// WEBPACK FOOTER //
// ./src/modules/views/docs/mocks/Samples.js